import { Role } from '@okletsplay/core';

export const REQUIRED_ROLES = [Role.User];
